import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// // redirect to login page whenever token is no longer valid
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       console.log('validated');
//       store.dispatch('users/setUnauthenticated');
//       this.$router.push('/login');
//     }
//     return Promise.reject(error);
//   },
// );

export default {
  namespaced: true,
  state: {
    application: {},
    applicationStatus: {
      full_name: '',
      issue_date: null,
      status: [],
    },
    summarizedApplications: [],
    careers: [],
    careerSuggestions: [],
    careerDetailed: null,
  },
  mutations: {
    updateApplication(state, newApplication) {
      state.application = newApplication;
    },
    updateSummarizedApplications(state, newApplications) {
      state.summarizedApplications = newApplications;
    },
    updateCareers(state, newCareers) {
      state.careers = newCareers;
    },
    updateCareerDetailed(state, newCarrer) {
      state.careerDetailed = newCarrer;
    },
    updateCareerSuggestions(state, newSuggestions) {
      state.careerSuggestions = newSuggestions;
    },
    updateApplicationStatus(state, newApplicationStatus) {
      state.applicationStatus = newApplicationStatus;
    },
  },
  actions: {
    postApplication(context, application) {
      console.log(application);
      const reqMethod = application.applicationInfo.id === 0 ? 'post' : 'put';
      const reqUrl = application.applicationInfo.id === 0
        ? '/api/application/apply/'
        : `/api/application/apply/edit/${application.applicationInfo.id}/`;
      return new Promise((resolve, reject) => {
        axios({
          url: reqUrl,
          method: reqMethod,
          data: application,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getApplication(context, applicationId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/application/${applicationId}/`,
          method: 'get',
        }).then((response) => {
          console.log('app data:', response.data);
          context.commit('updateApplication', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateApplication', {});
          reject(error.response.data);
        });
      });
    },
    getSummarizedApplications(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/summary/',
          method: 'get',
        }).then((response) => {
          context.commit('updateSummarizedApplications', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateSummarizedApplications', []);
          reject(error.response.data);
        });
      });
    },
    getApplicationStatus(context, applicationId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/application/application-status/${applicationId}/`,
          method: 'get',
        }).then((response) => {
          console.log('app data:', response.data);
          context.commit('updateApplicationStatus', response.data);
          resolve(response.data);
        }).catch((error) => {
          const applicationStatus = {
            full_name: '',
            issue_date: null,
            status: [],
          };
          context.commit('updateApplicationStatus', applicationStatus);
          reject(error.response.data);
        });
      });
    },
    postApplicationStatus(context, statusInfo) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/application-status/',
          method: 'post',
          data: statusInfo,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendMessage(context, messageInfo) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/contact-us/',
          method: 'post',
          data: messageInfo,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCareers(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/jobs/',
          method: 'get',
        }).then((response) => {
          context.commit('updateCareers', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateCareers', []);
          reject(error.response.data);
        });
      });
    },
    getCareerSuggestions(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/job-suggestions/',
          method: 'get',
        }).then((response) => {
          context.commit('updateCareerSuggestions', response.data.result);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateCareerSuggestions', []);
          reject(error.response.data);
        });
      });
    },
    getCareerDetails(context, careerId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/application/job/${careerId}/`,
          method: 'get',
        }).then((response) => {
          context.commit('updateCareerDetailed', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateCareerDetailed', null);
          reject(error.response.data);
        });
      });
    },
    postResume(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/application/job/post-resume/',
          method: 'post',
          data: formData,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    getApplication(state) {
      return state.application;
    },
    getSummarizedApplications(state) {
      return state.summarizedApplications;
    },
    getCareers(state) {
      return state.careers;
    },
    getCareerDetails(state) {
      return state.careerDetailed;
    },
    getCareerSuggestions(state) {
      return state.careerSuggestions;
    },
    getApplicationStatus(state) {
      return state.applicationStatus;
    },
  },
};
